import styled from '@emotion/styled';
import { ImageFitType } from 'src/domains/layouts/webview/components/common/lazyLoadingImage/common/LazyLoadingImageRaw.type';

interface ImagePropsType {
    allowShow: boolean;
    imgFit?: ImageFitType;
}

export const ImageRaw = styled('img', { label: 'ImageRaw' })<ImagePropsType>`
    ${({ imgFit }): string => (imgFit === undefined ? '' : `object-fit: ${imgFit}`)};
    display: block;
    height: auto;
    opacity: ${({ allowShow }): string => (allowShow ? '1' : '0')};
    transition: opacity 0.2s ease-in-out;
    width: 100%;
`;
